<div class="filter">
	<nha-popup [isOpen]="popupOpen()" [isClick]="true" (openChanged)="popupOpen.set($event)">
		<nha-chip [icon]="isSelected() ? 'check' : ''" iconSize="18px" popup-target [color]="isSelected() ? 'blue' : 'clear'" [text]="filterTitle()"></nha-chip>

		<div popup-content class="filter-chip-popup-container dense-2">
			<div class="filter-header">
				<span class="title">{{ filter().title }}</span>

				<div class="header-buttons">
					@if (!locked()) {
						<button mat-icon-button matTooltip="Clear Filter" type="button" (click)="deselectAllFilterItems()">
							<mat-icon>filter_list_off</mat-icon>
						</button>
					}

					<button mat-icon-button matTooltip="Close Filter" type="button" (click)="popupOpen.set(false)">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>

			<nha-filter-chip-content [key]="key()" [filterKey]="filterKey()" [filter]="filter()" [counts]="counts()"> </nha-filter-chip-content>
		</div>
	</nha-popup>
</div>
